import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import type { NameEntry } from './selectors/employees/name-entry';
import { joinWithAnd } from '../utilities/text';

import { functionNameWithAssignedNames } from './functionNameWithAssignedNames';
import type { ContactsAsUsers } from './selectors/partners/contacts-as-users';

export function meetingParticipantsText(
  meeting: any,
  functions: FunctionViewModel[],
  employees: NameEntry[],
  contactsAsUsers: ContactsAsUsers[],
  includeResponsible: boolean = false,
): string {
  let names: string[] = [];
  let responsibleFunctionEmployeeUuid = '';
  if (meeting.responsibleUuid) {
    const responsibleFunctionEmployee = functions.find((f) => {
      return f.uuid === meeting.responsibleUuid;
    });
    if (responsibleFunctionEmployee) {
      responsibleFunctionEmployeeUuid = responsibleFunctionEmployee.employees[0];
    }
  }
  if (includeResponsible && functions.length && meeting.responsibleUuid) {
    names = [functionNameWithAssignedNames(meeting.responsibleUuid, functions, employees)];
  }
  if (includeResponsible && meeting.responsibleEmployeeUuid) {
    const responsibleEmployee = employees.find((e) => {
      return e.uuid === meeting.responsibleEmployeeUuid;
    });
    if (responsibleEmployee) {
      names = [responsibleEmployee.name];
    }
  }
  if (meeting.participants?.length) {
    const participantNames = employees
      .filter((e) => {
        return (
          meeting.participants.includes(e.uuid) &&
          e.uuid !== meeting.responsibleEmployeeUuid &&
          e.uuid !== responsibleFunctionEmployeeUuid
        );
      })
      .map((e) => {
        return e.name;
      });
    names = names.concat(participantNames);
  }
  if (meeting.externalParticipants) {
    const contactNamesList = contactsAsUsers
      .filter((c) => {
        return meeting.externalParticipants.includes(c.uuid);
      })
      .map((c) => {
        return c.name + ' (' + c.partnerName + ')';
      });
    names = names.concat(contactNamesList);
  }
  return joinWithAnd(names);
}
